import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["blockRID", "view", "allViews", "changeView", "paramSources", "contractSources"];
import * as React from 'react';
import { Block } from './Block';

/**
 * The props of an extension component.
 */

export function createBlockExtension(Component) {
  return function (_ref) {
    var piral = _ref.piral,
      _ref$params = _ref.params,
      blockRID = _ref$params.blockRID,
      view = _ref$params.view,
      allViews = _ref$params.allViews,
      changeView = _ref$params.changeView,
      paramSources = _ref$params.paramSources,
      contractSources = _ref$params.contractSources,
      componentProps = _objectWithoutProperties(_ref$params, _excluded);
    var blockParams = {
      blockRID: blockRID,
      view: view,
      allViews: allViews,
      changeView: changeView,
      paramSources: paramSources,
      contractSources: contractSources
    };
    return /*#__PURE__*/React.createElement(Block, _extends({
      piletApi: piral
    }, blockParams), /*#__PURE__*/React.createElement(Component, _extends({
      piletApi: piral,
      blockRID: blockRID
    }, componentProps)));
  };
}